import React, {createContext, useContext, useReducer, useState} from "react";
import axios from 'axios'
import {commands, serverReducer} from "./ServerReducer";
import {ResetContext} from "../components/reset/ResetContext";
import {NotificatorContext} from "../components/Notificator";


export const ServerContext = createContext()


export const ServerProvider = ({children}) => {
    const {initTimer} = useContext(ResetContext)
    const {showNotification} = useContext(NotificatorContext)

    const [goods, dispatch] = useReducer(serverReducer, [], () => {
        return []
    })
    const [overview, setOverview] = useState(null)
    const [specs, setSpecs] = useState(null)
    const [buy, setBuy] = useState(null)
    const [orders, setOrders] = useState(null)
    const [mainLoading, setMainLoading] = useState(false)
    const [allPics, setAllPics] = useState(null)


    const makeGetRequest = async (url, callback, errCallback = null) => {
        const res = await axios.get(url)
        if (res.data) {
            callback(res.data)
        } else {
            if (errCallback) {
                errCallback(res)
            } else {
                showNotification('Something is wrong, try again')
            }
        }
    }

    const init = () => {
        setMainLoading(true)
        makeGetRequest('/api/goods', (data) => {
            data.map(good => {
                dispatch({type: commands.add_local, good})
                return good
            })
        })
        makeGetRequest('/api/timer', (data) => {
            if (data.time > 0) {
                initTimer(data.time)
            }
            setMainLoading(false)
        })
    }

    const reset = async (callback) => {
        const res = await axios.get('/init/reset')
        console.log(res.data)
        callback()
    }

    const getAllOrders = (callback) => {
        makeGetRequest('/order/getall', (data) => {
            setOrders(data)
            callback()
        })
    }

    const getAllPics = (callback) => {
        makeGetRequest('/api/pics', (data) => {
            setAllPics(data)
            callback()
        })
    }

    const addPic = async (image, callback) => {
        const formData = new FormData()
        if (image) {
            formData.append('image', image, image.name)
        }
        const res = await axios.post(`/api/update/addpic`, formData, {
            onUploadProgress: progressEvent => {
                console.log('Upload Progress:' + Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%')
            }
        })
        setAllPics(prev => prev.concat([res.data.src]))
        if (callback) {
            callback()
        }
        initTimer()
    }

    const removePic = async (src, callback) => {
        const res = await axios.post('/api/update/removepic', {src})
        setAllPics(prev => prev.filter(img => img !== src))
        console.log(res.data)
        if (callback) {
            callback()
        }
        initTimer()
    }

    const getOverview = async (overviewId, callback) => {
        setOverview(null)
        const res = await axios.get(`/api/overview/${overviewId}`)
        if (res.data) {
            if (res.status === 200) {
                console.log(res.data)
                setOverview(res.data)
            }
        }
        callback()
    }

    const getSpecs = async (specsId, callback) => {
        const res = await axios.get(`/api/specs/${specsId}`)
        if (res.data) {
            if (res.status === 200) {
                console.log(res.data)
                setSpecs(res.data.pages)
            }
        }
        callback()
    }

    const getBuy = async (buyId, callback) => {
        const res = await axios.get(`/api/buy/${buyId}`)
        if (res.data) {
            if (res.status === 200) {
                console.log(res.data)
                setBuy(res.data.options)
            }
        }
        callback()
    }

    /*const updateGood = async (goodId, good, image, callback) => {
        const formData = new FormData()
        if(image) {
            formData.append('image', image, image.name)
        }
        formData.append('good', JSON.stringify(good))
        const res = await axios.post(`/api/update/good/${goodId}`, formData, {
            onUploadProgress: progressEvent => {
                console.log('Upload Progress:' + Math.round((progressEvent.loaded/progressEvent.total)*100)+'%')
            }
        })
        console.log(res.data)
        callback()
        initTimer()
    }*/

    const updateGood = async (goodId, good, callback) => {
        console.log('updating good')
        const res = await axios.post(`/api/update/good/${goodId}`, good)
        console.log(res.data)
        callback()
        initTimer()
    }

    const updateOverview = async (overviewId, overview, callback) => {
        const res = await axios.post(`/api/update/overview/${overviewId}`, overview)
        console.log(res.data)
        callback()
        initTimer()
    }

    const updateSpecs = async (specsId, specs, callback) => {
        const res = await axios.post(`/api/update/specs/${specsId}`, specs)
        console.log(res.data)
        callback()
        initTimer()
    }

    const updateBuy = async (buyId, buy, callback) => {
        const res = await axios.post(`/api/update/buy/${buyId}`, buy)
        console.log(res.data)
        callback()
        initTimer()
    }


    return (
        <ServerContext.Provider value={{
            goods,
            mainLoading,
            init,
            getOverview,
            overview,
            getSpecs,
            specs,
            getBuy,
            buy,
            updateGood,
            updateOverview,
            updateSpecs,
            updateBuy,
            reset,
            getAllOrders,
            orders,
            getAllPics,
            removePic,
            addPic,
            pics: allPics
        }}>
            {children}
        </ServerContext.Provider>
    )
}